import React from "react";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { Tooltip } from "@material-ui/core";
import { IoMdCloseCircleOutline } from "react-icons/io";

class FullScreenDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: this.props.open
    };
  }

  /**
   * onload function
   * @param {*} newProps 
   */
  componentWillReceiveProps(newProps) {
    if (newProps.open != this.state.open) {
      this.setState({
        open: true
      });
    }
  }

  render() {
    const { isFullScreen = false } = this.props;
    return (
      <Dialog fullScreen={isFullScreen} open={this.state.open}>
        <AppBar style={{ position: "relative", backgroundColor: "#064473" }}>
          <Toolbar>
            <Typography variant={"h6"} style={{ flex: "1" }}>
              {this.props.title}
            </Typography>

            <Tooltip title={"Close"}>
              <IconButton
                title={"Close"}
                edge={"end"}
                color={"inherit"}
                onClick={this.props.close}
                aria-label={"close"}
                className={"white-button"}
              >
                <IoMdCloseCircleOutline />
              </IconButton>
            </Tooltip>
          </Toolbar>
        </AppBar>
        <div style={{ padding: "10px" }}>{this.props.children}</div>
      </Dialog>
    );
  }
}

export default FullScreenDialog;
